import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Bed: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <style type="text/css">
      {
        '\n\t.st0{fill:#FF612B;}\n\t.st1{fill:#002677;}\n\t.st2{fill:#FFFFFF;}\n'
      }
    </style>
    <g id="white_space" />
    <g id="Layer_1">
      <g>
        <g>
          <g>
            <path
              className="st0"
              d="M40.0534,21.1333H6.7999v-8.0267c0-0.6333-0.5134-1.1467-1.1467-1.1467h0 c-0.6333,0-1.1467,0.5134-1.1467,1.1467v22.9335h2.2933v-4.5867h34.4002v4.5867h2.2934V24.5733 C43.4935,22.6735,41.9533,21.1333,40.0534,21.1333z M6.7999,29.16v-5.7334h6.7524L13.5334,29.16H6.7999z"
            />
          </g>
          <path
            className="st1"
            d="M18.2666,21.1333H6.7999v-4.5867h7.4668c2.2091,0,4,1.7909,4,4V21.1333z"
          />
        </g>
        <rect
          x={6.7999}
          y={23.4267}
          className="st2"
          width={6.7524}
          height={5.7334}
        />
      </g>
    </g>
  </Box>
)
export default Bed
